import List from './list/AdditionalServiceListInitialState'

const { Record } = require('immutable')

export default Record({
    list: List()
})